import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=288aee48"
import script from "./VideoSelector.vue?vue&type=script&lang=js"
export * from "./VideoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288aee48')) {
      api.createRecord('288aee48', component.options)
    } else {
      api.reload('288aee48', component.options)
    }
    module.hot.accept("./VideoSelector.vue?vue&type=template&id=288aee48", function () {
      api.rerender('288aee48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/views/VideoSelector.vue"
export default component.exports